// extracted by css-extract-rspack-plugin
export default {"seo_text":"JWISB","seoText":"JWISB"};